/* eslint-disable no-nested-ternary */
import React, { useEffect, useMemo, useRef, useState } from 'react';

import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import 'mapbox-gl/dist/mapbox-gl.css';
// @ts-ignore	eslint-disable-next-line no-undef
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import Map, {
	Layer,
	LineLayer,
	MapRef,
	Marker,
	NavigationControl,
	Source,
} from 'react-map-gl';
import mapboxgl from 'utils/mapboxgl';
import type { FeatureCollection } from 'geojson';
import { LngLatBounds } from 'mapbox-gl';

import { ReactComponent as Back } from 'design_system/src/static/icons/back.svg';
import { ReactComponent as Menu } from 'design_system/src/static/icons/drag-indicator.svg';
import { ReactComponent as Action } from 'design_system/src/static/icons/more-v.svg';
import { ReactComponent as Reject } from 'design_system/src/static/icons/close-circle.svg';

import {
	Button,
	Input,
	ModalConfirmation,
	Popup,
	Select,
	Typography,
} from 'design_system/src';

import '../recovery.scss';
import {
	FetchRecoveries,
	FetchRoute,
	updateRecovery,
} from 'models/repossession/controllers/repossession.controller';
import { toasterOptions } from 'models/shared/enums/toaster.enum';
import {
	InterestPointStatus,
	InterestPointTypeValues,
} from 'models/repossession/enums/repossession.enums';
import {
	activeRecoveryStatuses,
	RecoveryCanceledConditions,
	RecoveryFinalConditions,
	RecoveryFinalConditionsValues,
	RecoveryStatus,
	RecoveryStatusValues,
} from 'models/repossession/enums/recovery.enums';
import { toasterNotification } from 'models/shared/helpers/toasterNotification';
import { Route } from 'models/repossession/interfaces/route.interface';
import { Recovery } from 'models/repossession/interfaces/recovery.interface';
import { commonErrorHandler } from 'models/shared/helpers/errors';
import {
	activeRouteStatuses,
	RouteStatusValues,
} from 'models/repossession/enums/route.enums';
import { LightTooltip } from 'components/hocs/tooltip/Tooltip';
import { momentLocal } from 'models/shared/helpers/dates';

export const RouteDetail = () => {
	const { _id } = useParams();

	const navigate = useNavigate();
	const mapRef = useRef<MapRef>(null);

	const [viewState, setViewState] = useState({
		longitude: -99.12766,
		latitude: 19.42847,
		zoom: 10,
	});

	const [route, setRoute] = useState<Route>();
	const [recoveries, setRecoveries] = useState<Recovery[]>();

	const [loading, setLoading] = useState(false);

	const [openConfirm, setOpenConfirm] = useState(false);
	const [selectedRecovery, setSelectedRecovery] = useState<Recovery>();
	const [canceledReason, setCanceledReason] =
		useState<RecoveryFinalConditions>();

	const [openAction, setOpenAction] = useState<Recovery | undefined>();
	const [isDragging, setIsDragging] = useState(false);

	const fetchData = () => {
		if (_id) {
			setLoading(true);
			const p = [];
			p.push(
				FetchRoute(_id).then((resp: Route) => {
					setRoute(resp);
				}),
			);

			p.push(
				FetchRecoveries(_id).then((recoveriesData) => {
					setRecoveries(recoveriesData.data.sort((a, b) => a.index - b.index));
				}),
			);

			Promise.all(p).then(() => {
				setLoading(false);
			});
		}
	};

	useEffect(() => {
		fetchData();
	}, [_id]);

	const cancelRecovery = () => {
		if (selectedRecovery) {
			setLoading(true);
			updateRecovery(selectedRecovery._id, {
				status: RecoveryStatus.canceled,
				finalCondition: canceledReason,
			})
				.then(() => {
					fetchData();
					clearSelecteds();
					toasterNotification({
						msg: 'Se cambio de estado la recuperacion',
						toasterType: toasterOptions.success,
						style: 'light',
					});
				})
				.catch((e) => {
					setLoading(false);
					commonErrorHandler(e);
				});
		}
	};
	const clearSelecteds = () => {
		setOpenConfirm(false);
		setSelectedRecovery(undefined);
		setCanceledReason(undefined);
		setOpenAction(undefined);
	};

	const reorderRecoveries = () => {
		setLoading(true);
		const p: Promise<Recovery>[] = [];
		recoveries
			?.filter((recovery, index) => recovery.index !== index)
			.forEach((recovery, index) => {
				p.push(
					updateRecovery(recovery._id, {
						index,
					}),
				);
			});

		Promise.all(p)
			.then(() => {
				fetchData();
				setIsDragging(false);
				toasterNotification({
					msg: 'Se cambio el orden de la ruta',
					toasterType: toasterOptions.success,
					style: 'light',
				});
			})
			.catch((e) => {
				setLoading(false);
				commonErrorHandler(e);
			});
	};
	// const cancelRecovery = (recovery: Recovery, reason: RecoveryFinalConditions ) => {}
	// 	if (recoveries) {
	// 		const changedRecoveries = [...recoveries];
	// 		const targetId = changedRecoveries.findIndex(
	// 			(item) => item._id === result.draggableId,
	// 		);
	// 		changedRecoveries[targetId].status = result.destination.droppableId;
	// 		setRecoveries(changedRecoveries);
	// 		updateRecovery(result.draggableId, {
	// 			status: result.destination.droppableId,
	// 		})
	// 			.then(() => {
	// 				fetchData();
	// 				toasterNotification({
	// 					msg: 'Se cambio de estado la recuperacion',
	// 					toasterType: toasterOptions.success,
	// 					style: 'light',
	// 				});
	// 			})
	// 			.catch((e) => {
	// 				fetchData();
	// 				commonErrorHandler(e);
	// 			});
	// 	}
	// };

	// const onDragEnd = (result: any) => {
	// 	if (recoveries) {
	// 		// dropped outside the list
	// 		if (
	// 			!result.destination ||
	// 			result.destination.droppableId === result.source.droppableId
	// 		) {
	// 			return;
	// 		}
	// 		if (result.destination.droppableId === RecoveryStatus.recovered) {
	// 			setOpenConfirm(true);
	// 			setConfirmData(result);
	// 		} else {
	// 			changeStatus(result);
	// 		}
	// 	}
	// };

	const onDragEnd = (result: any) => {
		// dropped outside the list
		if (!result.destination || !recoveries) {
			return;
		}

		const reorder = Array.from(recoveries);
		const [removed] = reorder.splice(result.source.index, 1);
		reorder.splice(result.destination.index, 0, removed);

		setRecoveries(reorder);
	};

	const markers = useMemo(() => {
		return (
			recoveries?.map((recovery, i) => {
				const Icon = InterestPointTypeValues[recovery.interestPoint.type].icon;
				return (
					<Marker
						key={recovery._id}
						longitude={recovery.interestPoint.coordinates.long}
						latitude={recovery.interestPoint.coordinates.lat}
					>
						<div
							className={`br_xxl main_marker cursor_pointer ${
								InterestPointTypeValues[recovery.interestPoint.type].color
							}`}
						>
							<div className="marker_info p_y_xs p_x_lg flex_center flex_gap_sm">
								<div
									className={`dim_lg pos_relative br_circle bg_${
										InterestPointTypeValues[recovery.interestPoint.type]
											.realColor
									}_nocontrast`}
								>
									<Typography
										weight="400"
										scale="xsmall"
										textColor="neutral_0"
										className="pos_absolute center"
									>
										{i + 1}
									</Typography>
								</div>
								<Typography weight="600" scale="small">
									{recovery.repossession.loan.vehicle.internalId}
								</Typography>
							</div>
							<div className="marker_details p_y_xxs p_x_md flex_center z_index_1 pos_relative">
								<Icon className="dim_lg icon" />
								<div className="p_x_md flex_center_col">
									<Typography weight="600" scale="xsmall">
										{momentLocal(recovery.createdAt).format('DD/MM/YYYY')}
									</Typography>
									<Typography weight="400" scale="xsmall">
										{momentLocal(recovery.createdAt).format('HH:mm')}
									</Typography>
								</div>
							</div>
							<span className="arrow" />
						</div>
					</Marker>
				);
			}) ?? []
		);
	}, [viewState.zoom, recoveries]);

	const routeLayer = useMemo(() => {
		const source: FeatureCollection = {
			type: 'FeatureCollection',
			features: [
				{
					type: 'Feature',
					properties: {},
					geometry: {
						type: 'LineString',
						coordinates:
							recoveries?.map((point) => [
								point.interestPoint.coordinates.long,
								point.interestPoint.coordinates.lat,
							]) ?? [],
					},
				},
			],
		};
		const layerStyle: LineLayer = {
			id: 'route',
			type: 'line',
			paint: {
				'line-color': '#888',
				'line-width': 3,
			},
		};
		return source?.features?.length ? (
			<Source type="geojson" data={source}>
				<Layer {...layerStyle} />
			</Source>
		) : null;
	}, [recoveries]);

	const getType = (item: Recovery) => {
		const type = InterestPointTypeValues[item.interestPoint.type];

		return (
			<div className="display_flex flex_gap_xs flex_align_center m_b_xs">
				<type.icon className={`dim_lg text_${type.realColor}`} />
				<Typography scale="small" weight="600">
					{type.title}
				</Typography>
			</div>
		);
	};
	useEffect(() => {
		if (recoveries?.length) {
			const bounds = new LngLatBounds();
			recoveries.forEach((point) => {
				bounds.extend([
					point.interestPoint.coordinates.long,
					point.interestPoint.coordinates.lat,
				]);
			});
			const size = (bounds.getEast() - bounds.getWest()) * 2.2;
			bounds.extend({
				lng: bounds.getWest() - size,
				lat: bounds.getNorth(),
			});
			mapRef.current?.fitBounds(bounds, { padding: 100 });
		}
	}, [recoveries]);

	return route && recoveries ? (
		<>
			<div className="dim_100_per flex_content_col shadow_hard inner_container bg_neutral_400">
				<div className="flex_header">
					<div className="bg_neutral_0 shadow_hard p_y_lg p_x_xxxl">
						<div className="display_flex flex_gap_md flex_align_center">
							<Button
								variant="icon"
								icon={<Back />}
								subvariant="edit"
								scale="small"
								onClick={() => navigate(-1)}
							/>
							<Typography
								scale="heading3"
								weight="600"
								textColor="primary_300"
								className="text_capitalize"
							>
								{moment
									.utc(route.routeDate)
									.locale('es')
									.format('dddd, D MMMM')}
							</Typography>
							<Typography
								weight="600"
								scale="large"
								textColor={RouteStatusValues[route.status].textColor as any}
								className={`bg_${
									RouteStatusValues[route.status].color
								}_nocontrast br_xl p_y_xxs p_x_sm m_y_xs`}
							>
								{RouteStatusValues[route.status].title}
							</Typography>
							{route.team.map((ozonio) => (
								<Typography
									scale="small"
									weight="600"
									textColor="neutral_900"
									className="bg_neutral_300 br_md p_y_xxs p_x_xs"
								>
									{ozonio.name}
								</Typography>
							))}
						</div>
					</div>
				</div>
				<div className="flex_body overflow_x_hidden">
					<div className="dim_100_per pos_relative">
						<div className="repossession_map_route_cont h_100_per w_40_per display_flex flex_col flex_gap_md">
							<div className="flex_content_col route_cont overflow_hidden br_xs shadow_hard bg_neutral_0 flex_grow_1">
								<div className="flex_header p_md p_b_none">
									<div className=" display_flex flex_gap_md ">
										{/* <Input
											type="short-date"
											name="fecha"
											title="Fecha de ruta"
											className="flex_basis_0 flex_grow_1"
											value={routeDate}
											onChange={(e: any) => setRouteDate(e.target.value)}
										/>
										<Input
											type="select"
											name="ozonio"
											title="Encargado"
											placeholder="Encargado"
											className="flex_basis_0 flex_grow_1"
											multiple
											options={ozonios}
											value={team}
											onChange={(e: any) => setTeam(e.target.value)}
										/> */}
									</div>
									<div className="display_flex flex_gap_md p_b_sm">
										<Typography
											scale="medium"
											weight="600"
											className="route_fixed_components text_center"
										>
											Orden
										</Typography>
										<Typography
											scale="medium"
											weight="600"
											className="route_fixed_components text_center"
										>
											Tipo
										</Typography>
										<Typography
											scale="medium"
											weight="600"
											className="flex_1 text_center"
										>
											Vehículo
										</Typography>
										<Typography
											scale="medium"
											weight="600"
											className="flex_1 text_center"
										>
											Estado
										</Typography>
										<div className="route_fixed_components" />
									</div>
								</div>
								<div className="flex_body p_md p_t_none display_flex flex_col ">
									<DragDropContext onDragEnd={onDragEnd}>
										<Droppable droppableId="droppable">
											{(provided: any, snapshot: any) => (
												<div
													{...provided.droppableProps}
													ref={provided.innerRef}
													className="flex_grow_1 bg_neutral_300 display_flex flex_col flex_gap_sm p_xxs"
												>
													{recoveries?.map((recovery, index) => {
														const icon =
															InterestPointTypeValues[
																recovery.interestPoint.type
															];

														return (
															<Draggable
																key={recovery._id}
																draggableId={recovery._id}
																index={index}
																isDragDisabled={
																	!activeRecoveryStatuses.includes(
																		recovery.status,
																	) || !isDragging
																}
															>
																{(provided2: any, snapshot2: any) => (
																	<div
																		className={`route_component  ${
																			snapshot2.isDragging
																				? 'bg_primary_50'
																				: 'bg_neutral_0'
																		}`}
																		ref={provided2.innerRef}
																		{...provided2.draggableProps}
																		{...provided2.dragHandleProps}
																		style={provided2.draggableProps.style}
																	>
																		<div className="display_flex flex_align_center flex_gap_md flex_justify_between p_y_sm">
																			<Typography
																				scale="medium"
																				weight="400"
																				className="route_fixed_components text_center"
																			>
																				{index + 1}
																			</Typography>
																			<LightTooltip title={icon.title}>
																				<div className="route_fixed_components flex_center">
																					<icon.icon
																						className={`dim_lg icon text_${icon.realColor}`}
																					/>
																				</div>
																			</LightTooltip>
																			<Typography
																				scale="medium"
																				weight="400"
																				className="flex_1 text_center"
																			>
																				{
																					recovery.repossession.loan.vehicle
																						.internalId
																				}
																			</Typography>
																			<Typography
																				scale="medium"
																				weight="400"
																				className="flex_1 text_center"
																			>
																				{
																					RecoveryStatusValues[recovery.status]
																						.title
																				}
																			</Typography>
																			<div className="route_fixed_components flex_center">
																				{activeRecoveryStatuses.includes(
																					recovery.status,
																				) ? (
																					isDragging ? (
																						<Menu className="dim_lg" />
																					) : (
																						<div className="pos_relative">
																							<Action
																								className="dim_md cursor_pointer border_transparent"
																								tabIndex={0}
																								role="button"
																								onKeyDown={() =>
																									setOpenAction(
																										openAction
																											? undefined
																											: recovery,
																									)
																								}
																								onClick={() =>
																									setOpenAction(
																										openAction
																											? undefined
																											: recovery,
																									)
																								}
																							/>
																							<Popup
																								open={
																									openAction?._id ===
																									recovery._id
																								}
																								setOpen={(action: boolean) =>
																									setOpenAction(
																										action
																											? recovery
																											: undefined,
																									)
																								}
																								placementX="right-inset"
																								className="bg_neutral_100 br_xxs"
																							>
																								<div
																									className="p_x_md p_y_xs action_option cursor_pointer"
																									tabIndex={0}
																									role="button"
																									onKeyDown={() => {
																										setOpenConfirm(true);
																										setSelectedRecovery(
																											recovery,
																										);
																									}}
																									onClick={() => {
																										setOpenConfirm(true);
																										setSelectedRecovery(
																											recovery,
																										);
																									}}
																								>
																									<Typography
																										scale="medium"
																										weight="400"
																										className="text_no_break"
																									>
																										Cancelar Ubicación
																									</Typography>
																								</div>
																							</Popup>
																						</div>
																					)
																				) : null}
																			</div>
																		</div>
																	</div>
																)}
															</Draggable>
														);
													})}
													{provided.placeholder}
												</div>
											)}
										</Droppable>
									</DragDropContext>
								</div>
								<div className="flex-footer p_md p_t_none">
									{isDragging ? (
										<div className="display_flex flex_gap_md">
											<Button
												scale="small"
												color="light_grey"
												className="w_100_per"
												onClick={() => {
													setIsDragging(false);
												}}
											>
												Cancelar
											</Button>
											<Button
												scale="small"
												className="w_100_per"
												onClick={() => {
													reorderRecoveries();
												}}
												disabled={loading}
											>
												Guardar cambios
											</Button>
										</div>
									) : activeRouteStatuses.includes(route?.status) ? (
										<Button
											scale="small"
											className="w_100_per"
											onClick={() => {
												setIsDragging(true);
											}}
											disabled={loading}
										>
											Reordenar Rutas
										</Button>
									) : null}
								</div>
							</div>
						</div>

						{/* <Button
							className="repossession_map_next_button"
							onClick={triggerCreateRoute}
							disabled={
								routeInterestPoints.length < 1 ||
								!routeDate ||
								routeDate === '' ||
								!team?.length ||
								loadingRoute
							}
						>
							Crear Ruta
						</Button> */}
						<Map
							mapLib={mapboxgl}
							mapboxAccessToken={process.env.REACT_APP_MAPBOX_API_KEY || ''}
							onMove={(evt) => setViewState(evt.viewState)}
							mapStyle="mapbox://styles/mapbox/streets-v9"
							reuseMaps
							ref={mapRef}
							{...viewState}
						>
							<NavigationControl position="bottom-right" />
							{routeLayer}
							{markers}
						</Map>
					</div>
				</div>
			</div>
			<ModalConfirmation
				openConfirmation={openConfirm}
				handleClose={() => clearSelecteds()}
				icon={<Reject className="text_red_300" />}
				widthDesktop={40}
				heightDesktop={80}
				isConfirmationLoading={false}
				actions={[
					{
						label: 'Volver',
						color: 'grey',
						action: () => clearSelecteds(),
					},
					{
						label: 'Cancelar',
						color: 'primary',
						action: () => cancelRecovery(),
						disabled: !selectedRecovery || !canceledReason || loading,
					},
				]}
			>
				<>
					<Typography scale="large" weight="600" className="m_b_xs">
						Cancelar este punto de recuperación
					</Typography>
					<Typography
						scale="medium"
						weight="400"
						className="m_b_md"
						textColor="neutral_700"
					>
						Estas seguro que quieres eliminar esta recuperación de la ruta
					</Typography>

					<Select
						value={canceledReason}
						onChange={(e: any) => setCanceledReason(e.target.value)}
						className="w_100_per"
						options={RecoveryCanceledConditions.map((key) => ({
							value: key,
							label: RecoveryFinalConditionsValues[key].title,
						}))}
					/>
				</>
			</ModalConfirmation>
		</>
	) : null;
};
